<template>
  <div
    class="lead-detail"
    :class="{ 'lead-detail--embedded': embedded, 'pb-20 md:pb-0': !embedded }"
  >
    <template v-if="resp.results && !embedded">
      <topsearch
        :title="'' + resp.results.name + ' #' + id"
        :favorite="favorite"
        :nextLeadId="nextLeadId"
      />
    </template>

    <div class="flex flex-col md:flex-row md:px-4" v-if="resp.results">
      <div class="w-full min-w-0 pt-4 md:w-3/4 md:mr-4 md:pr-4 md:border-r">
        <!-- Başlık -->
        <div
          class="flex flex-col md:flex-row md:items-start md:justify-between gap-4 px-3 md:px-0 pb-3"
        >
          <div class="flex items-start gap-3 min-w-0">
            <div class="lead-avatar">{{ initials }}</div>
            <div class="min-w-0">
              <h1
                class="text-xl md:text-2xl font-semibold text-gray-900 m-0 leading-tight break-words"
              >
                {{ resp.results.name }}
              </h1>
              <div class="flex flex-wrap items-center gap-2 mt-2">
                <span class="lead-chip">#{{ resp.results.id }}</span>
                <span v-if="statusLabel" class="lead-chip lead-chip--accent">
                  {{ statusLabel }}
                </span>
                <span
                  v-if="resp.results.is_customer == 1"
                  class="lead-chip lead-chip--success"
                  >Müşteri</span
                >
              </div>
            </div>
          </div>
          <div
            v-if="resp.results.is_customer == 0"
            class="flex-shrink-0"
            @click="showCustomerForm()"
          >
            <savebutton
              action="convertCustomer"
              icon="star"
              title="Müşteriye dönüştür"
            />
          </div>
        </div>

        <!-- İletişim -->
        <div class="flex flex-wrap items-center gap-2 px-3 md:px-0 pb-4">
          <span class="global-button-xs" title="Not sayısı">
            <svg
              xmlns="http://www.w3.org/2000/svg"
              class="w-4 h-4"
              viewBox="0 0 16 16"
            >
              <path fill="currentColor" d="M1 4.5A2.5 2.5 0 0 1 3.5 2h9A2.5 2.5 0 0 1 15 4.5v5a2.5 2.5 0 0 1-2.5 2.5H8.688l-3.063 2.68A.98.98 0 0 1 4 13.942V12h-.5A2.5 2.5 0 0 1 1 9.5zM3.5 3A1.5 1.5 0 0 0 2 4.5v5A1.5 1.5 0 0 0 3.5 11H5v2.898L8.312 11H12.5A1.5 1.5 0 0 0 14 9.5v-5A1.5 1.5 0 0 0 12.5 3z" />
            </svg>
            <span>{{ notSayisi }} not</span>
          </span>

          <template v-if="aranacakNo">
            <VDropdown v-if="aranacakNo.length == 10">
              <button type="button" class="global-button-xs">
                <svg
                  xmlns="http://www.w3.org/2000/svg"
                  class="w-4 h-4"
                  viewBox="0 0 24 24"
                >
                  <g fill="currentColor" fill-rule="evenodd" clip-rule="evenodd">
                    <path d="M22.75 7a5.75 5.75 0 1 0-10.9 2.56a.129.129 0 0 1 .013.04v.007l-.297 1.113a1.4 1.4 0 0 0 1.714 1.714l1.113-.298c-.002 0-.001 0 0 0h.007a.126.126 0 0 1 .04.014A5.75 5.75 0 0 0 22.75 7m-8.356 5.136h-.002zM17 2.75a4.25 4.25 0 1 1-1.892 8.057a1.567 1.567 0 0 0-1.102-.12l-.946.253l.253-.946a1.566 1.566 0 0 0-.12-1.102A4.25 4.25 0 0 1 17 2.75" />
                    <path d="M17 4.25a.75.75 0 0 1 .75.75v1.25H19a.75.75 0 0 1 0 1.5h-1.25V9a.75.75 0 0 1-1.5 0V7.75H15a.75.75 0 0 1 0-1.5h1.25V5a.75.75 0 0 1 .75-.75M3.007 6.407c1.68-1.68 4.516-1.552 5.685.544l.65 1.163c.763 1.368.438 3.095-.68 4.227a.63.63 0 0 0-.104.337c-.013.256.078.849.997 1.767c.918.918 1.51 1.01 1.767.997a.63.63 0 0 0 .337-.104c1.131-1.118 2.859-1.443 4.227-.68l1.163.65c2.096 1.17 2.224 4.005.544 5.685c-.899.898-2.094 1.697-3.498 1.75c-2.08.079-5.536-.459-8.958-3.88c-3.421-3.422-3.959-6.877-3.88-8.958c.053-1.405.852-2.6 1.75-3.498m4.376 1.275c-.6-1.074-2.21-1.32-3.315-.214c-.775.775-1.28 1.63-1.312 2.493c-.066 1.736.363 4.762 3.442 7.841c3.08 3.08 6.105 3.508 7.84 3.442c.863-.033 1.72-.537 2.494-1.312c1.106-1.106.86-2.716-.214-3.315l-1.163-.649c-.723-.403-1.74-.266-2.452.448c-.07.07-.517.486-1.308.524c-.81.04-1.791-.324-2.9-1.434c-1.111-1.11-1.475-2.091-1.435-2.902c.038-.791.455-1.237.524-1.306c.714-.714.851-1.73.448-2.453z" />
                  </g>
                </svg>
                <span>Hızlı Ara</span>
              </button>
              <template #popper>
                <div class="p-2 divide-y">
                  <div class="mb-4">
                    <select class="uk-select" v-model="aranacakNo">
                      <option>{{ resp.results.phone }}</option>
                      <option>{{ resp.results.phone_2 }}</option>
                      <option>{{ resp.results.mobile }}</option>
                    </select>
                  </div>
                  <div
                    class="text-sm cursor-pointer p-2"
                    @click="makeCall(0)"
                  >
                    <span>0 hattı</span>
                    <vk-spinner
                      v-if="loadingHat == 'hat0'"
                      ratio="0.5"
                    ></vk-spinner>
                  </div>
                  <div
                    class="text-sm cursor-pointer p-2"
                    @click="makeCall(80)"
                  >
                    <span>80 hattı</span>
                    <vk-spinner
                      v-if="loadingHat == 'hat80'"
                      ratio="0.5"
                    ></vk-spinner>
                  </div>
                  <div
                    class="text-sm cursor-pointer p-2"
                    @click="makeCall(90)"
                  >
                    <span>90 hattı</span>
                    <vk-spinner
                      v-if="loadingHat == 'hat90'"
                      ratio="0.5"
                    ></vk-spinner>
                  </div>
                  <div
                    v-for="prefix in $root.cache.callPrefixes"
                    :key="prefix.value"
                    class="text-sm cursor-pointer p-2"
                    @click="makeCall(prefix.value)"
                  >
                    <span>{{ prefix.label }}</span>
                    <vk-spinner
                      v-if="loadingHat == 'hat' + prefix.value"
                      ratio="0.5"
                    ></vk-spinner>
                  </div>
                  <div class="pt-2 text-gray-500">
                    <span
                      class="text-xs block w-60"
                      v-if="!$root.cache.me.dahili"
                      >Bu özellik çalışabilmesi için
                      <a href="/profile">profilinizde</a> dahiliniz tanımlı
                      olmalıdır.
                      {{ $root.cache.me.dahili }}</span
                    >
                    <span class="text-xs block w-60">
                      Lead detayındaki telefon bölümünde yazan numarayı arar,
                      aranacak numara :
                      {{ resp.results.phone }}</span
                    >
                  </div>
                </div>
              </template>
            </VDropdown>
            <span
              v-else
              class="global-button-xs text-gray-400"
              title="Telefonu eksik yada fazla"
            >
              <svg
                xmlns="http://www.w3.org/2000/svg"
                class="w-4 h-4"
                viewBox="0 0 24 24"
              >
                <path fill="currentColor" d="M14.52 17.35C11.39 19.83 7.36 21.22 3 20.97v-5.51l5.27-.61l2.52 2.52c.81-.41 1.58-.9 2.3-1.45L1.39 4.22l1.42-1.41L21.19 21.2l-1.41 1.41zm1.39-4.24c.56-.73 1.05-1.51 1.47-2.33l-2.53-2.53l.61-5.25h5.51c.25 4.37-1.15 8.4-3.63 11.54z" />
              </svg>
              <span>Telefon hatalı</span>
            </span>
            <a
              v-if="String(resp.results.phone || '').length == 10"
              class="global-button-xs text-green-600"
              target="_blank"
              rel="noopener"
              :href="'https://wa.me/' + phonefix"
            >
              <svg
                xmlns="http://www.w3.org/2000/svg"
                class="w-4 h-4"
                viewBox="0 0 24 24"
              >
                <path fill="currentColor" d="M12.04 2c-5.46 0-9.91 4.45-9.91 9.91c0 1.75.46 3.45 1.32 4.95L2.05 22l5.25-1.38c1.45.79 3.08 1.21 4.74 1.21c5.46 0 9.91-4.45 9.91-9.91c0-2.65-1.03-5.14-2.9-7.01A9.816 9.816 0 0 0 12.04 2m.01 1.67c2.2 0 4.26.86 5.82 2.42a8.225 8.225 0 0 1 2.41 5.83c0 4.54-3.7 8.23-8.24 8.23c-1.48 0-2.93-.39-4.19-1.15l-.3-.17l-3.12.82l.83-3.04l-.2-.32a8.188 8.188 0 0 1-1.26-4.38c.01-4.54 3.7-8.24 8.25-8.24M8.53 7.33c-.16 0-.43.06-.66.31c-.22.25-.87.86-.87 2.07c0 1.22.89 2.39 1 2.56c.14.17 1.76 2.67 4.25 3.73c.59.27 1.05.42 1.41.53c.59.19 1.13.16 1.56.1c.48-.07 1.46-.6 1.67-1.18c.21-.58.21-1.07.15-1.18c-.07-.1-.23-.16-.48-.27c-.25-.14-1.47-.74-1.69-.82c-.23-.08-.37-.12-.56.12c-.16.25-.64.81-.78.97c-.15.17-.29.19-.53.07c-.26-.13-1.06-.39-2-1.23c-.74-.66-1.23-1.47-1.38-1.72c-.12-.24-.01-.39.11-.5c.11-.11.27-.29.37-.44c.13-.14.17-.25.25-.41c.08-.17.04-.31-.02-.43c-.06-.11-.56-1.35-.77-1.84c-.2-.48-.4-.42-.56-.43c-.14 0-.3-.01-.47-.01Z" />
              </svg>
              <span>WhatsApp</span>
            </a>
          </template>

          <span
            v-if="resp.results.email"
            class="global-button-xs min-w-0 max-w-full"
          >
            <vk-icon icon="mail" ratio="0.8" />
            <span class="truncate">{{ resp.results.email }}</span>
          </span>
        </div>

        <!-- Müşteriye dönüştür -->
        <form
          v-if="showCustomerConverterForm"
          autocomplete="off"
          class="mx-3 md:mx-0 mb-4 p-4 border rounded-lg bg-white"
          @submit.prevent="convertCustomer()"
        >
          <div class="flex items-center gap-2 mb-4">
            <svg
              xmlns="http://www.w3.org/2000/svg"
              class="w-6 h-6 text-tile-500"
              viewBox="0 0 48 48"
            >
              <g
                fill="none"
                stroke="currentColor"
                stroke-linecap="round"
                stroke-linejoin="round"
                stroke-width="4"
              >
                <path d="m24 4l5.253 3.832l6.503-.012l1.997 6.188l5.268 3.812L41 24l2.021 6.18l-5.268 3.812l-1.997 6.188l-6.503-.012L24 44l-5.253-3.832l-6.503.012l-1.997-6.188l-5.268-3.812L7 24l-2.021-6.18l5.268-3.812l1.997-6.188l6.503.012z" />
                <path d="m17 24l5 5l10-10" />
              </g>
            </svg>
            <h3 class="text-base font-semibold text-gray-900 m-0">
              Müşteri Adayı Dönüştür
            </h3>
          </div>
          <div class="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-3 gap-4">
            <form-item
              v-for="name in convertFieldNames"
              :key="name"
              class="lead-item"
              :form="customerConvertForm"
              :input="fieldsMap[name]"
              :label="true"
              @changed="(g) => convertFormSet(g)"
              :value="customerConvertForm[name]"
              :type="fieldsMap[name].component.name"
            />
          </div>
          <div class="flex justify-end mt-4">
            <savebutton title="Dönüştür" action="convertCustomer" />
          </div>
        </form>

        <!-- Sekmeler -->
        <div class="border-b border-gray-200 mb-2">
          <nav class="lead-tabs px-3 md:px-0" aria-label="Tabs" role="tablist">
            <button
              v-for="tab in visibleTabs"
              :key="tab.key"
              type="button"
              role="tab"
              :id="'tab-' + tab.key"
              :aria-selected="activeTab === tab.key ? 'true' : 'false'"
              class="lead-tab"
              :class="{ 'lead-tab--active': activeTab === tab.key }"
              @click="changeTab(tab.key)"
            >
              {{ tab.label }}
            </button>
          </nav>
        </div>

        <!-- Kişisel bilgiler -->
        <div
          v-if="activeTab === 'kisisel-bilgiler'"
          class="text-sm px-3 md:px-0"
        >
          <div
            v-if="mode === 'layout'"
            class="flex flex-wrap items-center justify-between gap-2 py-2 mb-2"
          >
            <p class="text-xs text-gray-500 m-0">
              Alanları ve başlıkları sürükleyerek sıralayın. Bu düzen size
              özeldir.
            </p>
            <div class="flex items-center gap-2 ml-auto">
              <button
                type="button"
                class="global-button"
                @click="resetLayout()"
              >
                Varsayılana dön
              </button>
              <button
                type="button"
                class="primary-button"
                @click="finishLayout()"
              >
                Bitti
              </button>
            </div>
          </div>

          <form
            v-if="mode === 'view'"
            :key="formKey"
            autocomplete="off"
            class="leadEditForm"
            @submit.prevent="formSubmit()"
          >
            <div
              class="flex flex-col md:flex-row border-b pb-4 py-2 gap-2"
            >
              <form-item
                v-for="name in quickFieldNames"
                :key="name"
                class="flex-1 min-w-0 lead-item"
                :form="editForm"
                :input="fieldsMap[name]"
                :label="true"
                @changed="(g) => editFormSet(g)"
                :value="editForm[name]"
                :type="fieldsMap[name].component.name"
              />
            </div>

            <div class="flex items-center justify-end gap-2 my-4">
              <button
                type="button"
                class="global-button"
                title="Alan sırasını düzenle"
                @click="startLayout()"
              >
                <svg
                  xmlns="http://www.w3.org/2000/svg"
                  class="w-4 h-4"
                  viewBox="0 0 24 24"
                >
                  <path fill="currentColor" d="M9 20q-.825 0-1.412-.587T7 18t.588-1.412T9 16t1.413.588T11 18t-.587 1.413T9 20m6 0q-.825 0-1.412-.587T13 18t.588-1.412T15 16t1.413.588T17 18t-.587 1.413T15 20m-6-6q-.825 0-1.412-.587T7 12t.588-1.412T9 10t1.413.588T11 12t-.587 1.413T9 14m6 0q-.825 0-1.412-.587T13 12t.588-1.412T15 10t1.413.588T17 12t-.587 1.413T15 14M9 8q-.825 0-1.412-.587T7 6t.588-1.412T9 4t1.413.588T11 6t-.587 1.413T9 8m6 0q-.825 0-1.412-.587T13 6t.588-1.412T15 4t1.413.588T17 6t-.587 1.413T15 8" />
                </svg>
                <span class="hidden sm:inline">Sırala</span>
              </button>
              <savebutton action="formSubmit" />
            </div>

            <section
              v-for="section in visibleSections"
              :key="section.category"
              class="lead-section"
            >
              <h2 class="lead-section__title">{{ section.category }}</h2>
              <div class="grid grid-cols-1 sm:grid-cols-2 gap-x-6 gap-y-4">
                <div
                  v-for="name in section.fields"
                  :key="name"
                  class="lead-item min-w-0"
                >
                  <div v-if="isAssignmentTrackingField(name)">
                    <label>{{ fieldsMap[name].display_name }}</label>
                    <div
                      class="uk-input bg-gray-50 text-gray-600 flex items-center cursor-not-allowed"
                      title="Sistem tarafından otomatik doldurulur"
                    >
                      {{ displayValue(fieldsMap[name], resp.results[name]) }}
                    </div>
                  </div>
                  <form-item
                    v-else
                    :form="editForm"
                    :input="fieldsMap[name]"
                    :label="true"
                    @changed="(g) => editFormSet(g)"
                    :value="editForm[name]"
                    :type="fieldsMap[name].component.name"
                  />
                </div>
              </div>
            </section>

            <div class="flex justify-end my-4">
              <savebutton action="formSubmit" />
            </div>
          </form>

          <!-- Sıralama -->
          <draggable
            v-else
            v-model="sections"
            handle=".lead-section__handle"
            :animation="150"
          >
            <section
              v-for="section in sections"
              :key="section.category"
              class="lead-section"
            >
              <h2 class="lead-section__title lead-section__handle cursor-move">
                <svg
                  xmlns="http://www.w3.org/2000/svg"
                  class="w-4 h-4 text-gray-400"
                  viewBox="0 0 24 24"
                >
                  <path fill="currentColor" d="M4 15v-2h16v2zm0-4V9h16v2z" />
                </svg>
                <span>{{ section.category }}</span>
              </h2>
              <draggable
                v-model="section.fields"
                group="lead-fields"
                :animation="150"
                :delay="150"
                :delay-on-touch-only="true"
                ghost-class="lead-drag-ghost"
                class="lead-drop grid grid-cols-1 sm:grid-cols-2 gap-2"
              >
                <div
                  v-for="name in section.fields"
                  :key="name"
                  class="lead-drag"
                >
                  <svg
                    xmlns="http://www.w3.org/2000/svg"
                    class="w-4 h-4 flex-shrink-0 text-gray-400"
                    viewBox="0 0 24 24"
                  >
                    <path fill="currentColor" d="M9 20q-.825 0-1.412-.587T7 18t.588-1.412T9 16t1.413.588T11 18t-.587 1.413T9 20m6 0q-.825 0-1.412-.587T13 18t.588-1.412T15 16t1.413.588T17 18t-.587 1.413T15 20m-6-6q-.825 0-1.412-.587T7 12t.588-1.412T9 10t1.413.588T11 12t-.587 1.413T9 14m6 0q-.825 0-1.412-.587T13 12t.588-1.412T15 10t1.413.588T17 12t-.587 1.413T15 14M9 8q-.825 0-1.412-.587T7 6t.588-1.412T9 4t1.413.588T11 6t-.587 1.413T9 8m6 0q-.825 0-1.412-.587T13 6t.588-1.412T15 4t1.413.588T17 6t-.587 1.413T15 8" />
                  </svg>
                  <div class="min-w-0">
                    <div class="lead-field__label">
                      {{ fieldsMap[name].display_name }}
                    </div>
                    <div class="text-sm text-gray-700 truncate">
                      {{
                        fieldsMap[name].component.name === "clickShow"
                          ? "••••••"
                          : displayValue(fieldsMap[name], resp.results[name])
                      }}
                    </div>
                  </div>
                </div>
              </draggable>
            </section>
          </draggable>
        </div>

        <DublicatedLeads :id="id" v-if="activeTab === 'eslesen-kayitlar'" />

        <Journals
          :id="id"
          v-if="activeTab === 'gecmis'"
          :fieldsMap="fieldsMap"
        />

        <Files :id="id" v-if="activeTab === 'dosyalar'" />
        <AccountsVue
          :id="id"
          :modules="modules"
          :lead="resp.results"
          v-if="activeTab === 'platformlar'"
        />

        <Questions :id="id" v-if="activeTab === 'anketler'" />
        <Transaction
          :id="id"
          v-if="activeTab === 'para-islemleri'"
          :lead="resp.results"
        />

        <Tasks :id="id" v-if="activeTab === 'gorevler'" />
        <Remitters :id="id" v-if="activeTab === '3-sahis-bilgileri'" />
      </div>
      <div
        class="lead-detay-notes w-full md:w-1/4 border-t md:border-t-0 mt-6 md:mt-0 pt-4 md:pt-0 px-3 md:px-0"
      >
        <vk-tabs>
          <vk-tabs-item v-if="modules.includes('notlar')" title="Notlar">
            <Notes
              @notSayisi="(e) => (notSayisi = e)"
              table="lead_notes"
              class="mt-4 text-sm"
              :users="{
                agent: resp.results.agent_id,
                retention: resp.results.retention_id,
              }"
              field="lead_id"
              :id="id"
            />
          </vk-tabs-item>
          <vk-tabs-item v-if="modules.includes('emailler')" title="E-Posta">
            <Emails
              table="lead_emails"
              class="mt-4 text-sm"
              field="lead_id"
              :id="id"
            />
          </vk-tabs-item>
          <vk-tabs-item v-if="modules.includes('notlar')" title="Hatırlatmalar">
            <Notifications
              table="notifications"
              class="mt-4 text-sm"
              field="lead_id"
              :id="id"
            />
          </vk-tabs-item>
        </vk-tabs>
      </div>
    </div>
    <div v-else>
      <div v-if="loading" class="flex justify-center py-16 text-gray-400">
        <vk-spinner />
      </div>
      <div v-else>
        <div
          class="content-section flex"
          :class="embedded ? 'py-16' : 'min-h-screen'"
        >
          <div
            class="flex items-center mx-auto text-center justify-center flex-col px-4"
          >
            <img src="/img/svg/not-found.svg" />

            <h2 class="m-0 p-0">404</h2>
            <h3 class="m-0 p-0">
              Böyle bir kayıt yok yada görmeye yetkili değilsiniz
            </h3>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import draggable from "vuedraggable";
import moment from "moment";
import Journals from "../components/Ui/Lead/Journals";
import Files from "../components/Ui/Lead/Files";
import DublicatedLeads from "../components/Ui/Lead/DublicatedLeads";
import httpService from "../services/http";
import leadLayout from "../services/leadLayout";
import FormItemVue from "../components/Ui/FormItem";
import NotesVue from "../components/PageBuilder/Notes";
import Emails from "../components/PageBuilder/Emails";
import AccountsVue from "../modules/MetaTrader/Ui/Accounts";
import EventBus from "../components/Ui/EventBus";
import Questions from "../components/Ui/Lead/Questions";
import Tasks from "../components/Ui/Lead/Tasks";
import Transaction from "../components/Ui/Lead/Transaction";
import Remitters from "../components/Ui/Lead/Remitters";
import Notifications from "../components/PageBuilder/Notifications.vue";
import { readListContext } from "../services/listContext";

const TABLE = "leads";

// Devir takibi alanları sadece backend tarafından yazılır, detayda değiştirilemez
const ASSIGNMENT_TRACKING_FIELDS = [
  "prev_agent_id",
  "agent_assigned_at",
  "prev_retention_id",
  "retention_assigned_at",
];

const OPTION_COMPONENTS = ["selectbox", "leadStatus", "status", "multipleSelect"];
const DATE_COMPONENTS = ["date", "datetime", "editableDate", "birthday"];

const TABS = [
  { key: "kisisel-bilgiler", label: "KİŞİSEL BİLGİLER" },
  { key: "gorevler", label: "GÖREVLER", module: "gorevler" },
  { key: "platformlar", label: "PLATFORMLAR", module: "platformlar" },
  { key: "para-islemleri", label: "PARA İŞLEMLERİ", module: "para-islemleri" },
  { key: "eslesen-kayitlar", label: "EŞLEŞEN KAYITLAR", module: "eslesen-kayitlar" },
  { key: "gecmis", label: "GEÇMİŞ", module: "gecmis" },
  { key: "dosyalar", label: "DOSYALAR", module: "dosyalar" },
  { key: "anketler", label: "ANKETLER", module: "anketler" },
  { key: "3-sahis-bilgileri", label: "3. ŞAHIS BİLGİLERİ", module: "3-sahis-bilgileri" },
];

// Drawer'da lead'ler arasında gezerken alan tanımlarını tekrar çekmemek için
const fieldsCache = {};
function loadFields(table) {
  if (!fieldsCache[table]) {
    fieldsCache[table] = httpService
      .fields(table)
      .then((resp) => resp.data)
      .catch((e) => {
        delete fieldsCache[table];
        throw e;
      });
  }
  return fieldsCache[table];
}

export default {
  props: {
    // Drawer içinde gösterilirken route yerine bu id kullanılır
    leadId: { type: [String, Number], default: null },
    embedded: { type: Boolean, default: false },
  },
  components: {
    "form-item": FormItemVue,
    draggable,
    AccountsVue,
    Notes: NotesVue,
    Journals,
    Emails,
    Files,
    DublicatedLeads,
    Notifications,
    Questions,
    Tasks,
    Transaction,
    Remitters,
  },
  data() {
    return {
      resp: {},
      aranacakNo: null,
      showCustomerConverterForm: false,
      editForm: {},
      customerConvertForm: {},
      fields: [],
      fieldsMap: {},
      sections: [],
      mode: "view",
      saving: false,
      formKey: 0,
      notSayisi: 0,
      nextLeadId: false,
      activeTab: this.getInitialTab(),
      modules: [],
      favorite: {},
      loading: true,
      loadingHat: "",
      phonefix: 0,
      leads_filters: [],
    };
  },
  computed: {
    id() {
      return this.leadId || this.$route.params.id;
    },
    userId() {
      return (this.$root.cache.me && this.$root.cache.me.id) || "default";
    },
    visibleTabs() {
      return TABS.filter(
        (tab) => !tab.module || this.modules.includes(tab.module)
      );
    },
    visibleSections() {
      return this.sections.filter((section) => section.fields.length);
    },
    initials() {
      const name = String(
        (this.resp.results && this.resp.results.name) || ""
      ).trim();
      if (!name) {
        return "?";
      }
      const parts = name.split(/\s+/);
      const first = parts[0].charAt(0);
      const last = parts.length > 1 ? parts[parts.length - 1].charAt(0) : "";
      return (first + last).toLocaleUpperCase("tr-TR");
    },
    statusLabel() {
      const field = this.fieldsMap.status_id;
      if (
        !field ||
        !this.resp.results ||
        this.isEmpty(this.resp.results.status_id)
      ) {
        return "";
      }
      return this.displayValue(field, this.resp.results.status_id);
    },
    // Formun üstündeki öncelikli alanlar (orijinal sıra)
    quickFieldNames() {
      return ["name", "phone", "status_id", "utm_source", "email"].filter(
        (name) => this.fieldsMap[name] && this.resp.results[name] !== undefined
      );
    },
    convertFieldNames() {
      let occupation = null;
      if (this.fieldsMap.occupation_id) {
        occupation = "occupation_id";
      } else if (this.fieldsMap.occupation) {
        occupation = "occupation";
      }
      return [
        "retention_id",
        "retention_md_id",
        "tc",
        occupation,
        "city",
        "ilce",
      ].filter((name) => name && this.fieldsMap[name]);
    },
  },
  watch: {
    leadId(value, oldValue) {
      if (value && value !== oldValue) {
        this.mode = "view";
        this.getData(value);
      }
    },
  },
  methods: {
    isAssignmentTrackingField(name) {
      return ASSIGNMENT_TRACKING_FIELDS.includes(name);
    },
    isEmpty(value) {
      return value === null || value === undefined || value === "";
    },
    // Seçim alanlarında 0 "atanmamış" demektir (ör. retention_id = 0)
    isBlank(field, value) {
      if (this.isEmpty(value)) {
        return true;
      }
      const component = field.component && field.component.name;
      return (
        OPTION_COMPONENTS.includes(component) &&
        String(value) === "0" &&
        this.optionLabel(field, value) === value
      );
    },
    optionLabel(field, value) {
      const options =
        this.$root.cache.getOptions && this.$root.cache.getOptions[field.id];
      if (!Array.isArray(options)) {
        return value;
      }
      const option = options.find((o) => o.value == value);
      return option ? option.label : value;
    },
    displayValue(field, value) {
      if (this.isBlank(field, value)) {
        return "—";
      }
      const component = field.component && field.component.name;
      if (component === "password") {
        return "••••••";
      }
      if (component === "multipleSelect") {
        return String(value)
          .split(",")
          .filter((v) => v !== "")
          .map((v) => this.optionLabel(field, v))
          .join(", ");
      }
      if (OPTION_COMPONENTS.includes(component)) {
        return this.optionLabel(field, value);
      }
      if (
        DATE_COMPONENTS.includes(component) ||
        /_at$|_date$/.test(field.name)
      ) {
        if (String(value).indexOf("0000-00-00") === 0) {
          return "—";
        }
        const hasTime = String(value).length > 10;
        const parsed = moment(
          value,
          hasTime ? "YYYY-MM-DD HH:mm:ss" : "YYYY-MM-DD",
          true
        );
        if (parsed.isValid()) {
          return parsed.format(hasTime ? "DD.MM.YYYY HH:mm" : "DD.MM.YYYY");
        }
      }
      return value;
    },
    buildSections() {
      const readable = this.fields.filter(
        (field) => this.resp.results[field.name] !== undefined
      );
      this.sections = leadLayout.build(
        readable,
        leadLayout.load(TABLE, this.userId)
      );
    },
    startLayout() {
      this.mode = "layout";
    },
    finishLayout() {
      leadLayout.save(TABLE, this.userId, this.sections);
      this.mode = "view";
      this.$root.successMessage("Alan düzeni kaydedildi");
    },
    resetLayout() {
      leadLayout.reset(TABLE, this.userId);
      this.buildSections();
    },
    // Drawer, kaydedilmemiş değişiklik varken geçişte uyarmak için kullanır
    isEditing() {
      const results = this.resp.results;
      if (!results) {
        return false;
      }
      return Object.keys(this.editForm).some(
        (key) =>
          !this.isAssignmentTrackingField(key) &&
          String(this.editForm[key] == null ? "" : this.editForm[key]) !==
            String(results[key] == null ? "" : results[key])
      );
    },
    makeCall(ek) {
      this.loadingHat = "hat" + ek;
      httpService
        .makeCall({
          phone: ek + this.aranacakNo,
          lead_id: ek + this.resp.results.id,
        })
        .then(() => {
          this.loadingHat = "";
        })
        .catch(() => {
          this.loadingHat = "";
        });
    },
    showCustomerForm() {
      this.showCustomerConverterForm = !this.showCustomerConverterForm;
      this.customerConvertForm = Object.assign({}, this.resp.results);
    },
    convertFormSet(val) {
      this.customerConvertForm[val.name] = val.value;
    },
    convertCustomer() {
      if (
        confirm(
          "Bu işlem geri alınamaz, bu başvuruyu müşteri yapmak istediğinize eminmisiniz ?"
        )
      ) {
        httpService
          .convertCustomer(this.id, this.customerConvertForm)
          .then((response) => {
            if (response.data.success) {
              EventBus.$emit("bottomMessage", {
                open: true,
                type: "success",
                title: "Yeni Müşteri",
                duration: 2000,
                body: "Tebrikler 1 müşteri daha kazandınız",
              });

              this.showCustomerConverterForm = false;
              if (this.embedded) {
                this.getData(this.id);
              } else {
                location.reload();
              }
            }
          });
      }
    },
    onReloadLead(id) {
      this.getData(id || this.id);
    },
    formSubmit() {
      if (this.saving) {
        return;
      }
      EventBus.$emit("loadingStatus", {
        action: "formSubmit",
        loading: true,
      });

      this.editForm.phone = this.formatPhoneNumber(this.editForm.phone);

      const inputs = Object.assign({}, this.editForm);
      ASSIGNMENT_TRACKING_FIELDS.forEach((name) => delete inputs[name]);

      this.saving = true;
      httpService
        .detailSave({
          table: TABLE,
          id: this.id,
          inputs,
        })
        .then((response) => {
          if (response.data.success == true) {
            EventBus.$emit("loadingStatus", {
              action: "formSubmit",
              loading: false,
              success: true,
            });
            EventBus.$emit("bottomMessage", {
              open: true,
              type: "success",
              duration: 2000,
              body: "Güncelleme başarılı",
            });
            // Başlık hemen güncellensin; backend'in yazdığı alanlar
            // (önceki temsilci, atanma tarihi vb.) için kayıt tekrar okunur
            this.resp.results = Object.assign({}, this.resp.results, inputs);
            this.refreshResults().then((results) => {
              this.$emit("saved", this.id);
              if (results) {
                // Açık listelerde bu satır yerinde güncellensin
                EventBus.$emit("leadSaved", { id: this.id, results });
              }
            });
          } else {
            EventBus.$emit("loadingStatus", {
              action: "formSubmit",
              loading: false,
              success: false,
            });
            this.$root.errorMessage(
              "İşlem başarısız, yaptığınız işlemi tekrar kontrol ediniz"
            );
          }
        })
        .catch(() => {
          EventBus.$emit("loadingStatus", {
            action: "formSubmit",
            loading: false,
            success: false,
          });
          this.$root.errorMessage(
            "İşlem başarısız, yaptığınız işlemi tekrar kontrol ediniz"
          );
        })
        .finally(() => {
          this.saving = false;
        });
    },
    editFormSet(val) {
      this.editForm[val.name] = val.value;
    },
    phoneFixSet() {
      this.phonefix = "90" + this.formatPhoneNumber(this.resp.results.phone);
      this.aranacakNo = null;
      if (this.resp.results.phone) {
        this.aranacakNo = this.formatPhoneNumber(this.resp.results.phone);
      } else if (this.resp.results.mobile) {
        this.aranacakNo = this.formatPhoneNumber(this.resp.results.mobile);
      } else if (this.resp.results.phone_2) {
        this.aranacakNo = this.formatPhoneNumber(this.resp.results.phone_2);
      }
    },
    formatPhoneNumber(phoneNumber) {
      if (phoneNumber) {
        let numericPart = String(phoneNumber).replace(/\D/g, "");
        numericPart = numericPart.startsWith("90")
          ? numericPart.slice(2)
          : numericPart;
        numericPart = numericPart.startsWith("0")
          ? numericPart.slice(1)
          : numericPart;
        return numericPart.replace(/(\d{3})(\d{3})(\d{2})(\d{2})/, "$1$2$3$4");
      }
      return phoneNumber;
    },
    changeTab(tab) {
      this.activeTab = tab;
      if (!this.embedded) {
        window.location.hash = tab;
      }
    },
    getInitialTab() {
      if (this.embedded) {
        return "kisisel-bilgiler";
      }
      // Sayfa yüklendiğinde, hash değerine göre aktif sekme belirle
      return window.location.hash.slice(1) || "kisisel-bilgiler";
    },
    // Kaydı tekrar okur, formu yeniden kurmadan görünen verileri günceller.
    // editForm yerinde güncellenir: form-item'lar form referansı değişince
    // değerlerini sıfırladığı için yeni nesne atanmaz.
    refreshResults() {
      return httpService
        .getLeadDetail(TABLE, this.id, this.trxParam())
        .then((resp) => {
          const results = resp.data && resp.data.results;
          if (!results) {
            return null;
          }
          this.resp.results = results;
          Object.keys(results).forEach((key) => {
            if (Object.prototype.hasOwnProperty.call(this.editForm, key)) {
              this.editForm[key] = results[key];
            }
          });
          this.phoneFixSet();
          return results;
        })
        .catch(() => null);
    },
    // İşlem linkinden (?trx=) açılan sayfada erişim bu parametreye bağlı olabilir
    trxParam() {
      return !this.embedded && this.$route.query.trx > 0
        ? this.$route.query.trx
        : 0;
    },
    getData(id) {
      return httpService
        .getLeadDetail(TABLE, id, this.trxParam())
        .then((resp) => {
          this.resp = resp.data;
          this.modules = this.resp.modules || [];
          if (this.resp.results) {
            this.editForm = Object.assign({}, this.resp.results);
            this.formKey++;
            this.phoneFixSet();
            this.buildSections();
            this.favorite = {
              title: this.resp.results.name,
              url: "/leadDetail/" + this.resp.results.id,
            };
          }
        })
        .finally(() => {
          this.loading = false;
        });
    },
  },
  beforeDestroy() {
    // Her lead kartı ziyaretinde dinleyici birikip kapanmış kartlar için de
    // istek atıyordu.
    EventBus.$off("reloadLead", this.onReloadLead);
  },
  mounted() {
    EventBus.$on("reloadLead", this.onReloadLead);

    if (!this.embedded) {
      // Kart açılır açılmaz hesaplanır: kullanıcı kaydı güncelleyince sıralama
      // sütunu (ör. updated_at) değişse de "sonraki" listedeki yerine göre kalır.
      this.leads_filters = readListContext("leads_filters");
      httpService
        .getNextLead(this.leads_filters, this.id)
        .then((resp) => {
          // null: listenin sonu (false: henüz hesaplanıyor)
          this.nextLeadId = (resp.data && resp.data.id) || null;
        })
        .catch(() => {
          this.nextLeadId = null;
        });
    }
  },
  async created() {
    try {
      this.fields = await loadFields(TABLE);
    } catch (e) {
      this.fields = [];
    }
    const fieldsMap = {};
    this.fields.forEach((field) => {
      fieldsMap[field.name] = field;
    });
    this.fieldsMap = fieldsMap;

    this.getData(this.id);
  },
};
</script>

<style>
.lead-avatar {
  @apply flex-shrink-0 w-12 h-12 rounded-full bg-tile-50 text-tile-600 flex items-center justify-center text-lg font-semibold;
}

.lead-chip {
  @apply inline-flex items-center px-2 py-0.5 rounded-full text-xs font-medium bg-gray-100 text-gray-600;
}

.lead-chip--accent {
  @apply bg-tile-50 text-tile-700;
}

.lead-chip--success {
  @apply bg-green-50 text-green-700;
}

.lead-tabs {
  @apply flex space-x-4 overflow-x-auto;
  scrollbar-width: none;
}

.lead-tabs::-webkit-scrollbar {
  display: none;
}

.lead-tab {
  @apply font-semibold py-3 px-1 inline-flex items-center border-b-2 border-transparent text-sm whitespace-nowrap text-gray-500 bg-transparent cursor-pointer;
}

.lead-tab:hover {
  @apply text-tile-500;
}

.lead-tab--active {
  @apply border-tile-500 text-tile-500;
}

.lead-section {
  @apply py-4 border-b border-gray-100;
}

.lead-section:last-of-type {
  @apply border-b-0;
}

.lead-section__title {
  @apply flex items-center space-x-2 text-xs font-medium uppercase tracking-wide text-tile-500 m-0 mb-3 p-0;
}

.lead-field__label {
  @apply text-xs font-medium uppercase tracking-wide text-gray-500 mb-1;
}

.lead-item h3 {
  margin: 0px;
  font-size: 15px;
  font-weight: 500;
  color: #222;
  padding: 0px;
  padding-top: 5px;
}

.lead-item div label {
  color: #555 !important;
  font-weight: 500;
  font-size: 13px;
  margin-bottom: 2px;
  text-transform: uppercase !important;
}

.leadEditForm {
  margin: 0px;
}

.leadEditForm ul {
  padding: 0px;
  margin: 0px;
}

.lead-drop {
  min-height: 48px;
  @apply rounded-lg;
}

.lead-drag {
  @apply flex items-center space-x-2 border border-gray-200 rounded-lg bg-white px-3 py-2 cursor-move;
}

.lead-drag:hover {
  @apply border-tile-300;
}

.lead-drag-ghost {
  @apply opacity-50 bg-tile-50 border-tile-300;
}

.uk-heading-bullet {
  font-weight: 500;
}
</style>
